// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1Equm","Open":"SideDrawer_Open__1dgf5","Close":"SideDrawer_Close__MXxC8","Logo":"SideDrawer_Logo__1bwT2"};